/**
 * Displays the project information row in the cost estimate detail page.
 *
 * @param {{
 *   label: string;
 *   value: string | React.ElementType;
 *   rawHTML?: boolean;
 * }}
 */
export default function ProjectInformationRow({ label, value, rawHTML = false }) {
  return (
    <div className="flex flex-row gap-4 text-[15px] leading-[18px]">
      <div className="min-h-[36px] w-[240px] py-2">
        <div className="h-full">
          <span>{label}</span>
        </div>
      </div>
      <div className="min-h-[36px] w-[532px] py-2 [&_p:last-child]:mb-0 [&_p]:mb-2">
        {rawHTML ? <div dangerouslySetInnerHTML={{ __html: value }} /> : <div>{value}</div>}
      </div>
    </div>
  );
}
